"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_native_1 = require("react-native");
const react_redux_1 = require("react-redux");
const slice_1 = __importDefault(require("../../app-reduxs/app/slice"));
const Colors_1 = __importDefault(require("../../assets/colors/Colors"));
const images_1 = require("../../assets/images");
const rootNavigation_1 = require("../../navigators/rootNavigation");
const Routes_1 = __importDefault(require("../../navigators/Routes"));
const helpler_1 = require("../../utils/helpler");
const scale_1 = require("../../utils/scale");
const syncStorage_1 = require("../../utils/syncStorage");
const button_1 = require("../button");
const CustomText_1 = __importDefault(require("../text/CustomText"));
const ModalWelcome = () => {
    const dispatch = (0, react_redux_1.useDispatch)();
    const isVisible = (0, react_redux_1.useSelector)((state) => state.appReducer.requestLoginModal);
    const refShouldSaveToStorage = (0, react_1.useRef)(false);
    const onClose = () => {
        dispatch(slice_1.default.actions.hideRequestLoginModal());
        if (refShouldSaveToStorage.current) {
            refShouldSaveToStorage.current = false;
            (0, syncStorage_1.asyncStorageSetItem)("welcome_show", '1');
        }
    };
    (0, react_1.useEffect)(() => {
        checkShowModal();
    }, []);
    const checkShowModal = async () => {
        const isShow = await (0, syncStorage_1.asyncStorageGetItem)("welcome_show");
        if (isShow == '1')
            return;
        refShouldSaveToStorage.current = true;
        dispatch(slice_1.default.actions.showRequestLoginModal());
    };
    return (react_1.default.createElement(react_native_1.Modal, { visible: isVisible, animationType: "none", statusBarTranslucent: true, transparent: true, onRequestClose: onClose, onShow: () => {
            helpler_1.isWeb && document.body.classList.add("prevent-slice-modal");
        }, onDismiss: () => {
            helpler_1.isWeb && document.body.classList.remove("prevent-slice-modal");
        } },
        react_1.default.createElement(react_native_1.View, { style: styles.container },
            react_1.default.createElement(react_native_1.View, { style: styles.box },
                react_1.default.createElement(react_native_1.Image, { source: images_1.images.LogoTitle, style: styles.logo }),
                react_1.default.createElement(CustomText_1.default, { weight: '600', style: styles.title }, "\u6295\u8CC7\u306E\u5148\u8F29\u30B3\u30DF\u30E5\u30CB\u30C6\u30A3\u3078\u3088\u3046\u3053\u305D\uFF01"),
                react_1.default.createElement(CustomText_1.default, { style: styles.description }, 'メンバーになると、\n限定コンテンツを楽しんだり、\n先輩投資家とコメントで交流できます✨'),
                react_1.default.createElement(button_1.LinearButton, { fontWeight: '600', title: '\u30ED\u30B0\u30A4\u30F3\u30FB\u4ECA\u3059\u3050\u53C2\u52A0', style: styles.primaryButton, textStyle: styles.primaryButtonLabel, containerStyle: { marginTop: (0, scale_1.scale)(24) }, onPress: () => {
                        (0, rootNavigation_1.navigate)(Routes_1.default.AUTH_NAVIGATOR, { screen: Routes_1.default.LOGIN });
                        onClose();
                    } }),
                react_1.default.createElement(CustomText_1.default, { style: styles.cancelButton, onPress: onClose }, "\u4ECA\u306F\u53C2\u52A0\u3057\u306A\u3044")))));
};
exports.default = ModalWelcome;
const styles = react_native_1.StyleSheet.create({
    container: {
        flex: 1,
        backgroundColor: Colors_1.default.textHeaderOpacity60,
        justifyContent: 'center',
        alignItems: 'center',
    },
    box: {
        width: (0, scale_1.scale)(343),
        paddingHorizontal: (0, scale_1.scale)(16),
        paddingVertical: (0, scale_1.scale)(24),
        backgroundColor: '#FEFEFE',
        borderRadius: (0, scale_1.scale)(12),
    },
    logo: {
        width: (0, scale_1.scale)(110),
        height: (0, scale_1.scale)(24),
        alignSelf: 'center'
    },
    title: {
        marginTop: (0, scale_1.scale)(24),
        fontSize: (0, scale_1.moderateScale)(16),
        lineHeight: (0, scale_1.moderateScale)(24),
        color: '#292A33',
        textAlign: 'center',
    },
    description: {
        marginTop: (0, scale_1.scale)(4),
        fontSize: (0, scale_1.moderateScale)(15),
        lineHeight: (0, scale_1.moderateScale)(22.5),
        color: '#292A33',
        textAlign: 'center'
    },
    primaryButton: {
        width: '100%',
        height: (0, scale_1.scale)(48),
        borderRadius: (0, scale_1.scale)(4),
    },
    primaryButtonLabel: {
        fontSize: (0, scale_1.moderateScale)(16),
        lineHeight: (0, scale_1.moderateScale)(24),
        color: '#FEFEFE'
    },
    cancelButton: {
        alignSelf: 'center',
        marginTop: (0, scale_1.scale)(20),
        fontSize: (0, scale_1.moderateScale)(14),
        lineHeight: (0, scale_1.moderateScale)(21),
        color: '#007AFF'
    }
});
